export default function (Alpine) {

    Alpine.data('tabs', () => ({

        _active:            null,
        _tabs:              [],
        _panels:            [],
        _triggers:          [],   // harici tetikleyiciler
        _cleanup:           [],
        _autoplayInterval:  0,
        _autoplayTimer:     null,
        _scrollIntoView:    false,
        _loop:              true,

        init() {
            const root = this.$root;
            const self = this;

            root.setAttribute('data-tabs', '');

            self._tabs = [...root.querySelectorAll('[tab]')];

            self._panels = [...document.querySelectorAll('[panel]')].filter(el => {
                const sel = el.getAttribute('panel');
                try { return root.matches(sel); } catch { return false; }
            });

            if (!self._tabs.length)   console.warn('[tabs] tab bulunamadı. wrapper içinde [tab] attr eksik.');
            if (!self._panels.length) console.warn('[tabs] panel bulunamadı. [panel] selector wrapper\'ı eşleştiremiyor.');

            self._initTabs();
            self._initPanels();
            self._initExternalTriggers();

            // Başlangıç tab'ı: URL hash → selected attr → ilk aktif tab
            const hash    = location.hash.slice(1);
            const fromUrl = self._tabs.find(t => t.getAttribute('tab') === hash && !t.hasAttribute('disabled'));
            const initial = fromUrl
                ?? self._tabs.find(t => t.hasAttribute('selected') && !t.hasAttribute('disabled'))
                ?? self._tabs.find(t => !t.hasAttribute('disabled'));

            if (initial) self._activate(initial.getAttribute('tab'), false);

            // Hash değişince tab değiş
            const onHash = () => {
                const h = location.hash.slice(1);
                if (self._tabs.find(t => t.getAttribute('tab') === h)) self._activate(h, false);
            };
            window.addEventListener('hashchange', onHash);
            self._cleanup.push({ el: window, type: 'hashchange', fn: onHash });

            // DOM değişikliklerini izle — sonradan eklenen trigger'lar için
            self._observer = new MutationObserver(() => self._syncExternalTriggers());
            self._observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tab-trigger', 'tab-for'] });
        },

        destroy() {
            this._cleanup.forEach(({ el, type, fn }) => el.removeEventListener(type, fn));
            this._cleanup = [];
            this._stopAutoplay();
            this._observer?.disconnect();
        },


        _initTabs() {
            const self = this;

            self._tabs.forEach(tab => {
                const id       = tab.getAttribute('tab');
                const disabled = tab.hasAttribute('disabled');

                tab.setAttribute('role', 'tab');
                tab.setAttribute('tabindex', disabled ? '-1' : '0');
                tab.setAttribute('aria-controls', `tabpanel-${id}`);
                if (disabled) tab.setAttribute('aria-disabled', 'true');

                const onClick = (e) => {
                    if (disabled) { e.preventDefault(); return; }
                    self._activate(id);
                };

                const onKeydown = (e) => {
                    const active = self._tabs.filter(t => !t.hasAttribute('disabled'));
                    const idx    = active.indexOf(tab);
                    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                        e.preventDefault();
                        const nextIdx = idx + 1;
                        if (nextIdx < active.length) active[nextIdx].click();
                        else if (self._loop) active[0]?.click();
                    }
                    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                        e.preventDefault();
                        const prevIdx = idx - 1;
                        if (prevIdx >= 0) active[prevIdx].click();
                        else if (self._loop) active[active.length - 1]?.click();
                    }
                    if (e.key === 'Home') { e.preventDefault(); active[0]?.click(); }
                    if (e.key === 'End')  { e.preventDefault(); active[active.length - 1]?.click(); }
                };

                tab.addEventListener('click',   onClick);
                tab.addEventListener('keydown', onKeydown);
                self._cleanup.push(
                    { el: tab, type: 'click',   fn: onClick },
                    { el: tab, type: 'keydown', fn: onKeydown },
                );
            });
        },

        _initPanels() {
            this._panels.forEach(panel => {
                const id = panel.getAttribute('for');
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('id', `tabpanel-${id}`);
                panel.setAttribute('tabindex', '0');
                if (panel.hasAttribute('lazy')) panel.setAttribute('lazy-pending', '');
            });
        },

        // ─── Harici Trigger'lar ───────────────────────────────────────────────

        /**
         * Harici tetikleyici:
         *   <button tab-trigger="settings" tab-for="#myTabs">Settings'i aç</button>
         *
         * tab-for: herhangi bir CSS selector (id, class, attr).
         * Bir tab için birden fazla trigger olabilir.
         * Trigger'lar aktif olduğunda [trigger-active] attr alır.
         */
        _initExternalTriggers() {
            const self = this;
            const root = self.$root;

            // Bu wrapper'a ait tüm harici trigger'ları bul
            const allTriggers = [...document.querySelectorAll('[tab-trigger][tab-for]')].filter(el => {
                const sel = el.getAttribute('tab-for');
                try { return root.matches(sel); } catch { return false; }
            });

            // Önceki listener'ları temizle
            self._triggers.forEach(({ el, fn }) => {
                el.removeEventListener('click', fn);
                self._cleanup = self._cleanup.filter(c => !(c.el === el && c.type === 'click' && c.fn === fn));
            });
            self._triggers = [];

            allTriggers.forEach(trigger => {
                const id       = trigger.getAttribute('tab-trigger');
                const disabled = trigger.hasAttribute('disabled');

                trigger.setAttribute('role', 'button');
                if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', disabled ? '-1' : '0');

                const fn = (e) => {
                    if (disabled) { e.preventDefault(); return; }
                    // Tab yoksa uyar ama yine de dene — dinamik tab eklenmiş olabilir
                    const exists = self._tabs.find(t => t.getAttribute('tab') === id && !t.hasAttribute('disabled'));
                    if (!exists) { console.warn(`[tabs] "${id}" tab'ı bulunamadı veya disabled.`); return; }
                    self._activate(id);
                    if (self._scrollIntoView) {
                        root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                };

                trigger.addEventListener('click', fn);
                self._triggers.push({ el: trigger, fn });
                self._cleanup.push({ el: trigger, type: 'click', fn });

                // Klavye desteği (Space / Enter tetikler)
                const onKey = (e) => {
                    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); trigger.click(); }
                };
                trigger.addEventListener('keydown', onKey);
                self._cleanup.push({ el: trigger, type: 'keydown', fn: onKey });
            });

            // Mevcut aktif duruma göre trigger state'lerini güncelle
            if (self._active !== null) self._updateTriggerStates(self._active);
        },

        _syncExternalTriggers() {
            // MutationObserver'dan tetiklenir — yeni trigger'lar eklenince yeniden init et
            this._initExternalTriggers();
            if (this._active !== null) this._updateTriggerStates(this._active);
        },

        _updateTriggerStates(id) {
            const root = this.$root;
            // Bu wrapper'a ait tüm trigger'ları tara (hem kayıtlılar hem yeniler)
            document.querySelectorAll('[tab-trigger][tab-for]').forEach(el => {
                const sel = el.getAttribute('tab-for');
                let matches = false;
                try { matches = root.matches(sel); } catch {}
                if (!matches) return;

                const isActive = el.getAttribute('tab-trigger') === id;
                el.toggleAttribute('trigger-active', isActive);
                el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        },

        // ─────────────────────────────────────────────────────────────────────


        _getDuration(el) {
            const s = getComputedStyle(el);
            const t = parseFloat(s.transitionDuration) || 0;
            const a = parseFloat(s.animationDuration)  || 0;
            return Math.max(t, a) * 1000;
        },

        _activate(id, updateHash = true) {
            const self   = this;
            if (self._active === id) return;
            const prevId = self._active;
            self._active = id;

            self._tabs.forEach(tab => {
                const isActive = tab.getAttribute('tab') === id;
                tab.toggleAttribute('active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
                if (isActive && self._scrollIntoView) {
                    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                }
            });

            // Harici trigger state'lerini güncelle
            self._updateTriggerStates(id);

            // Panel'ları güncelle
            self._panels.forEach(panel => {
                const panelId  = panel.getAttribute('for');
                const isActive = panelId === id;
                const isPrev   = panelId === prevId;

                if (isPrev && prevId !== null) {
                    panel.setAttribute('closing', '');
                    const dur = self._getDuration(panel);
                    if (dur > 0) {
                        setTimeout(() => {
                            panel.removeAttribute('closing');
                            panel.removeAttribute('active');
                        }, dur);
                    } else {
                        panel.removeAttribute('closing');
                        panel.removeAttribute('active');
                    }
                } else if (!isActive) {
                    panel.removeAttribute('active');
                    panel.removeAttribute('closing');
                    panel.removeAttribute('opening');
                }

                if (isActive) {
                    panel.setAttribute('opening', '');
                    panel.toggleAttribute('active', true);

                    if (panel.hasAttribute('lazy-pending')) {
                        panel.removeAttribute('lazy-pending');
                        panel.setAttribute('lazy-loaded', '');
                        panel.dispatchEvent(new CustomEvent('tab:load', { bubbles: true }));
                    }

                    const dur = self._getDuration(panel);
                    if (dur > 0) {
                        setTimeout(() => panel.removeAttribute('opening'), dur);
                    } else {
                        panel.removeAttribute('opening');
                    }
                }
            });

            if (updateHash) history.replaceState(null, '', `#${id}`);

            this.$root.dispatchEvent(new CustomEvent('tab:change', {
                detail: { active: id, previous: prevId },
                bubbles: true,
            }));
        },

        go(id) {
            if (this._tabs.find(t => t.getAttribute('tab') === id && !t.hasAttribute('disabled'))) this._activate(id);
        },

        next() {
            this._tabs.find(t => t.getAttribute('tab') === this._active)?.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowRight', bubbles: true }));
        },

        prev() {
            this._tabs.find(t => t.getAttribute('tab') === this._active)?.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowLeft', bubbles: true }));
        },

        addTab(id, label, panelSelector, content = '') {
            const self = this;
            const root = self.$root;

            if (self._tabs.find(t => t.getAttribute('tab') === id)) {
                console.warn(`[tabs] "${id}" zaten var.`); return;
            }

            const tab = document.createElement('button');
            tab.setAttribute('tab', id);
            tab.setAttribute('role', 'tab');
            tab.setAttribute('tabindex', '-1');
            tab.textContent = label;
            root.appendChild(tab);
            self._tabs.push(tab);

            const panelEl = document.querySelector(panelSelector);
            if (panelEl) {
                const panel = document.createElement('div');
                panel.setAttribute('panel', panelSelector);
                panel.setAttribute('for', id);
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('id', `tabpanel-${id}`);
                panel.setAttribute('tabindex', '0');
                panel.innerHTML = content;
                panelEl.appendChild(panel);
                self._panels.push(panel);
            }

            self._initTabs();
            self._initExternalTriggers();
            self.$root.dispatchEvent(new CustomEvent('tab:added', { detail: { id }, bubbles: true }));
        },

        removeTab(id) {
            const self = this;

            const tab = self._tabs.find(t => t.getAttribute('tab') === id);
            if (!tab) { console.warn(`[tabs] "${id}" bulunamadı.`); return; }

            const panel = self._panels.find(p => p.getAttribute('for') === id);

            self._tabs   = self._tabs.filter(t => t !== tab);
            self._panels = self._panels.filter(p => p !== panel);

            tab.remove();
            panel?.remove();

            if (self._active === id) {
                const next = self._tabs.find(t => !t.hasAttribute('disabled'));
                if (next) self._activate(next.getAttribute('tab'));
                else self._active = null;
            }

            self.$root.dispatchEvent(new CustomEvent('tab:removed', { detail: { id }, bubbles: true }));
        },

        _startAutoplay() {
            const self = this;
            self._stopAutoplay();
            self._autoplayTimer = setInterval(() => {
                const active = self._tabs.find(t => t.getAttribute('tab') === self._active);
                active?.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowRight', bubbles: true }));
            }, self._autoplayInterval);
        },

        _stopAutoplay() {
            if (this._autoplayTimer) {
                clearInterval(this._autoplayTimer);
                this._autoplayTimer = null;
            }
        },

        pauseAutoplay()  { this._stopAutoplay(); },
        resumeAutoplay() { if (this._autoplayInterval > 0) this._startAutoplay(); },

    }));

}

/*
══════════════════════════════════════════════════════════════════════════════
 TEMEL KULLANIM
══════════════════════════════════════════════════════════════════════════════

<div x-data="tabs" id="myTabs">
  <button tab="overview">Overview</button>
  <button tab="settings" selected>Settings</button>
  <button tab="billing" disabled>Billing</button>
</div>

<div panel="#myTabs" for="overview">Overview içeriği</div>
<div panel="#myTabs" for="settings">Settings içeriği</div>
<div panel="#myTabs" for="billing" lazy>Lazy panel</div>


══════════════════════════════════════════════════════════════════════════════
 HARİCİ TETİKLEYİCİLER (YENİ)
══════════════════════════════════════════════════════════════════════════════

Sayfanın herhangi bir yerine yerleştirilebilir, sayı sınırı yok:

  <button tab-trigger="settings" tab-for="#myTabs">Settings'i aç</button>
  <button tab-trigger="settings" tab-for="#myTabs">Başka bir Settings butonu</button>
  <a    tab-trigger="overview"  tab-for="#myTabs">Overview'e git</a>
  <div  tab-trigger="billing"   tab-for=".myTabs">Billing</div>

tab-for: herhangi bir CSS selector (id, class, attr, vb.)
  tab-for="#myTabs"    → id ile
  tab-for=".myTabs"    → class ile
  tab-for="[data-nav]" → attribute ile

Aktif trigger → [trigger-active] attribute + aria-pressed="true" alır.
Disabled      → disabled attribute ile devre dışı bırakılabilir.


══════════════════════════════════════════════════════════════════════════════
 CSS HOOK'LARI
══════════════════════════════════════════════════════════════════════════════

  [tab][active]              → aktif tab
  [tab]:not([active])        → pasif tab
  [panel][active]            → görünen panel
  [panel]:not([active])      → gizli panel
  [panel][opening]           → panel açılıyor (transition/animation süresi)
  [panel][closing]           → panel kapanıyor (transition/animation süresi)
  [lazy-pending]             → henüz yüklenmemiş lazy panel
  [lazy-loaded]              → yüklenmiş lazy panel

  [tab-trigger][trigger-active]         → aktif triggerı işaretle
  [tab-trigger]:not([trigger-active])   → pasif trigger


══════════════════════════════════════════════════════════════════════════════
 ATTRİBUTELER — Wrapper
══════════════════════════════════════════════════════════════════════════════

  x-data="tabs"       Alpine data (zorunlu)
  autoplay="3000"     ms cinsinden otomatik geçiş (0 = kapalı)
  scroll-into-view    aktif tab görünür alana scroll edilir
  no-loop             son tab'dan sonra başa dönme, ilkten önce sona gitme


══════════════════════════════════════════════════════════════════════════════
 ATTRİBUTELER — Tab (wrapper içinde)
══════════════════════════════════════════════════════════════════════════════

  tab             tab id (zorunlu)
  selected        başlangıçta aktif
  disabled        devre dışı


══════════════════════════════════════════════════════════════════════════════
 ATTRİBUTELER — Panel
══════════════════════════════════════════════════════════════════════════════

  panel           wrapper CSS selector (zorunlu)
  for             tab id (zorunlu)
  lazy            ilk açılana kadar tab:load tetiklenmez


══════════════════════════════════════════════════════════════════════════════
 ATTRİBUTELER — Harici Trigger (YENİ)
══════════════════════════════════════════════════════════════════════════════

  tab-trigger     hedef tab id (zorunlu)
  tab-for         wrapper CSS selector (zorunlu)
  disabled        devre dışı


══════════════════════════════════════════════════════════════════════════════
 JS API
══════════════════════════════════════════════════════════════════════════════

  const api = document.getElementById('myTabs')._x_dataStack[0];

  api.go('settings')
  api.next()
  api.prev()
  api.addTab('newid', 'Label', '#myTabs', '<p>içerik</p>')
  api.removeTab('newid')
  api.pauseAutoplay()
  api.resumeAutoplay()


══════════════════════════════════════════════════════════════════════════════
 OLAYLAR
══════════════════════════════════════════════════════════════════════════════

  tab:change  → e.detail: { active, previous }
  tab:added   → e.detail: { id }
  tab:removed → e.detail: { id }
  tab:load    → lazy panel ilk kez açıldığında


══════════════════════════════════════════════════════════════════════════════
 URL HASH
══════════════════════════════════════════════════════════════════════════════

  Sayfa #settings ile açılırsa o tab aktif gelir.
  Tab değişince URL hash otomatik güncellenir.
*/